import { Add } from '@bnnvara/icons/src/components/UserInterfaceIcons/Add';
import { Check } from '@bnnvara/icons/src/components/UserInterfaceIcons/Check';
import PropTypes from 'prop-types';
import React from 'react';
import BaseButton from '../BaseButton';
import * as S from './styled';

const FollowBrandButton = ({
  color,
  isFollowedByUser,
  onClick
}) => {
  const text = isFollowedByUser ? 'Volgend' : 'Volgen';
  const button = isFollowedByUser ? /*#__PURE__*/React.createElement(Check, {
    color: "currentColor"
  }) : /*#__PURE__*/React.createElement(Add, {
    color: "currentColor"
  });
  return /*#__PURE__*/React.createElement(S.FollowBrandButton, {
    onClick: onClick,
    color: color
  }, /*#__PURE__*/React.createElement(BaseButton, {
    size: "small",
    variant: color === 'black' ? 'outline' : 'ghost',
    type: "button"
  }, button, /*#__PURE__*/React.createElement(S.TextFollow, null, " ", text, " ")));
};

FollowBrandButton.propTypes = {
  isFollowedByUser: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string
};
FollowBrandButton.defaultProps = {
  color: 'white'
};
export default FollowBrandButton;